import ContactCTA from "./ContactCTA";
import Hero from "./Hero";
// import Portfolio from "./Portfolio"; // Remove this
import DevelopmentProcess from "./DevelopmentProcess"; // Add this
import Services from "./Services";
import WhyChooseUs from "./WhyChooseUs";

export default function HomePage() {
    return (
      <>
        <Hero />
        <Services />
        <WhyChooseUs />
        {/* <Portfolio /> */} {/* Comment out or remove Portfolio */}
        <DevelopmentProcess /> {/* Add DevelopmentProcess */}
        {/* <Testimonials /> */}
        <ContactCTA />
      </>
    );
  }